export default function SideArrow() {
  return (
    <path
      fill="currentColor"
      d="M47.247 22.164l-.022-.025-.02-.016-9.442-9.362c-1.027-1.018-2.693-1.014-3.715.009-.495.495-.766 1.153-.765 1.852.002.698.277 1.355.774 1.848l4.955 4.912H2.626C1.178 21.382 0 22.556 0 24c0 1.442 1.178 2.616 2.626 2.616h36.386l-4.955 4.913c-.497.493-.772 1.15-.774 1.848-.001.699.27 1.357.765 1.852.513.513 1.187.77 1.862.77.67 0 1.34-.254 1.852-.761l9.425-9.344.02-.015.04-.044c.486-.492.753-1.143.753-1.835s-.267-1.343-.753-1.835"
    />
  )
}
